// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__13src","consentsList":"PatientConsents_consentsList__kxe4T","consentsListEmpty":"PatientConsents_consentsListEmpty__1bMxI"};